import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = {
  ref: "chartContainer",
  class: "tv-chart-container h-[550px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton = _resolveComponent("skeleton")!

  return (!_ctx.hardHideChart)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (!_ctx.init)
          ? (_openBlock(), _createBlock(_component_skeleton, { key: 0 }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
          [_vShow, _ctx.init]
        ])
      ]))
    : _createCommentVNode("", true)
}